import { ref } from "vue";


export function useSaveScroll() {
    const scrollRestored = ref(false);
    const saveScroll = () => {
        if(scrollRestored.value) {
            sessionStorage.setItem('product-list-scroll', JSON.stringify({ scrollY: window.scrollY, url: location.href }));
        }
    }

    const restoreScrollOnce = () => {
        if(!scrollRestored.value) {
            const scrollState = JSON.parse(sessionStorage.getItem('product-list-scroll') ?? 'null');
            if (scrollState && scrollState.url === location.href) {
                window.scrollTo({ top: scrollState.scrollY, behavior: 'instant' });
            }
            scrollRestored.value = true;
        }
    }

    document.addEventListener('click', (e) => {
        if((e.target as HTMLElement)?.closest('a')) {
            saveScroll();
        }
    });

    if (history.scrollRestoration) {
        history.scrollRestoration = "manual";
    }

    return {
        saveScroll,
        restoreScrollOnce,
    }
}
